import * as React from "react";
import * as ReactDOM from "react-dom/client";

import CartCount from "../../components/Cart/CartCount/cart-count";
import CartDrawer from "../../components/Cart/CartDrawer/CartDrawer";
import CartFooter from "../../components/Cart/CartFooter/cart-footer";

import { getCart } from "../../components/Cart/cartRepo";

export async function setupCartCountWidget() {
  const cart = await getCart(); // async api call

  let count = 0,
    total = 0;

  if (cart) {
    count = cart.Items.reduce(
      (accumulator, currentValue) => accumulator + currentValue.Quantity,
      0
    );
    total = cart.MerchandiseTotal;
  }

  const cartRoots = document.querySelectorAll("[data-cart]");

  const roots: Array<ReactDOM.Root> = [];

  cartRoots.forEach((el: Element) => {
    const root = ReactDOM.createRoot(el);
    roots.push(root);
  });

  roots.forEach((root) => {
    root.render(<CartCount count={count} total={total} />);
  });

  // setup cart drawer
  const cartDrawerEl = document.querySelector(
    "[data-cart-drawer]"
  ) as HTMLElement;

  if (cartDrawerEl) {
    const cartDrawerRoot = ReactDOM.createRoot(cartDrawerEl);
    cartDrawerRoot.render(<CartDrawer />);
  }

  // setup cart footer
  const cartFooterEl = document.querySelector(
    "[data-cart-footer]"
  );

  if (cartFooterEl) {
    const cartFooterRoot = ReactDOM.createRoot(cartFooterEl);

    cartFooterRoot.render(
      <CartFooter>
        <CartCount count={count} total={total} />
      </CartFooter>
    );
  }
}
